import styled from "styled-components";
import { BaseFlex, FlexRow, FlexColumn } from "pro-features/styled components/StyledFlex/src/StyledFlex";
import { colorsPalettes } from "@similarweb/styles";
import { setFontVariant } from "@similarweb/styles";

export const StepHeaderWrapper = styled(FlexRow)`
    padding-right: 12px;
    width: 100%;
    box-sizing: border-box;
    justify-content: space-between;
    align-items: center;
    ${setFontVariant("input2", colorsPalettes.carbon[300])};
`;

const Body = styled(FlexColumn)`
    margin: 0 24px 24px 64px;
    width: 100%;
`;
export const Title = styled(BaseFlex)<{ isOpen: boolean }>`
    margin-bottom: 2px;
    ${({ isOpen }) =>
        isOpen
            ? setFontVariant("subtitle1", colorsPalettes.carbon[500])
            : setFontVariant("input2", colorsPalettes.carbon[300])};

    align-items: center;
`;
const Description = styled(BaseFlex)`
    ${setFontVariant("body2", colorsPalettes.carbon[500])};
    align-items: center;
    margin-bottom: 24px;
    margin-right: 40px;
`;
const ButtonsWrapper = styled(FlexRow)`
    justify-content: space-between;
`;
